<table class="action-permissions">
  <tr *ngFor="let actionPermissionVM of userVM.allActionPermissionVMs">
    <td>
      <span
        (click)="
          userVM.editableUser.roles[actionPermissionVM.value] =
            !userVM.editableUser.roles[actionPermissionVM.value]
        "
        >{{ actionPermissionVM.displayTitle }}</span
      >
    </td>
    <td>
      <evrideo-checkbox
        [active]="!!userVM.editableUser.roles[actionPermissionVM.value]"
        (activeChange)="
          userVM.editableUser.roles[actionPermissionVM.value] = $event
        "
      ></evrideo-checkbox>
    </td>
  </tr>
</table>
